
import { CustomerLeadProductDto } from './customer-lead-product.dto';
import { CustomerBusinessType } from '../../enum/piecloud-signup';

export class CustomerLeadDto {
  id?: number;
  firstName!: string;
  lastName!: string;
  contactEmail!: string;
  contactPhone?: string;
  contactPhoneCountryId?: number;
  contactPhoneCountry?: Country;
  brandName?: string;
  businessName!: string;
  companyNumber?: string;
  businessCity?: City;
  businessCityId?: number;
  businessAddress?: string;
  businessAddressLine2?: string;
  businessAddressPostCode?: string;
  businessURL?: string;
  noLocations?: string;
  businessType?: CustomerBusinessType;
  active?: boolean;
  status?: string;
  description?: string;
  merchantGroupName?: string;
  merchantName?: string;
  merchantEmail?: string;
  merchantPhone?: string;
  merchantPhoneCountryId?: number;
  merchantPhoneCountry?: Country;
  merchantCityId?: number;
  merchantCity?: City;
  merchantAddress?: string;
  isSameAddress?: boolean;
  merchantPostCode?: string;
  customerLeadProduct?: CustomerLeadProductDto;
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
}

export class City {
  id?: number;
  name?: string;
  countryId?: number;
  country?: Country;
}

export class Country {
  id?: number;
  name?: string;
  phoneCode?: string;
  countryCode?: string;
  cities?: City[];
}
